import { Alert, CircularProgress, Container, Link } from '@mui/material'
import { useEffect, useState } from 'preact/hooks'
import { useLocation } from 'preact-iso'
import { api, type ErrorMessages, errorMessage } from '../api/client'
import type { Me } from '../api/generated/Me'
import { type LoginLink, parseLoginLink } from '../auth/loginLink'
import { takeNext } from '../auth/next'
import { useSession } from '../auth/session'

const expired: Record<LoginLink['endpoint'], ErrorMessages> = {
  '/auth/link': {},
  '/auth/qr': { challenge_expired: 'Ce QR code a expiré ou a déjà servi. Demandez-en un nouveau.' },
  '/auth/google': { challenge_expired: 'La connexion Google a expiré. Recommencez.' },
}

export function LoginVerify() {
  const { setMe } = useSession()
  const { route } = useLocation()
  const [error, setError] = useState<string>()

  useEffect(() => {
    const { hash, search, pathname } = window.location
    const link = parseLoginLink(hash, search)
    history.replaceState(null, '', pathname)
    if (!link) {
      // Google sends back `error` instead of a code when the user cancels
      setError(
        new URLSearchParams(search).has('error')
          ? 'Connexion Google annulée.'
          : 'Lien de connexion incomplet.',
      )
      return
    }
    api.post<Me>(link.endpoint, link.body).then(
      (me) => {
        setMe(me)
        const remembered = takeNext()
        route(link.next ?? remembered, true)
      },
      (e: unknown) => setError(errorMessage(e, expired[link.endpoint])),
    )
  }, [])

  return (
    <Container maxWidth="xs" sx={{ py: 6, textAlign: 'center' }}>
      {error ? (
        <Alert severity="error" action={<Link href="/login">Se connecter</Link>}>
          {error}
        </Alert>
      ) : (
        <CircularProgress />
      )}
    </Container>
  )
}
